import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Button, Card, CardBody, Row, Col } from 'reactstrap';

import useAxios from 'hooks/useAxios';
import Drawer from 'components/Drawer';
import ErrorBoundary from 'components/ErrorBoundary';
import PatientDetails from './components/PatientDetails';
import PatientDetailsTab from './components/PatientDetailsTab';
import PatientDetailsTable from './components/PatientDetailsTable';
import ClaimApproveReject from 'components/ClaimApproveReject';
import Arrow from "assets/icon/left-arrow.svg";

const Patient = (props) => {
  const { module, orgId, tenantID, patientIDNAME, isfax, coveredEntity, showpatientdetails,
    setShowPatientDetails, showpatientdetailsfax, refetch,
    setShowPatientDetailsfax,
  } = props;
  const API = useAxios();
  const location = useLocation()
  const navigate = useNavigate()
  // const { tenantID, patientId, isfax } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [operationType, setOperationType] = useState('');
  const [claimIDs, setClaimIDs] = useState([]);
  const [rxNumbers, setRxNumbers] = useState([]);
  const [patientDetails, setPatientDetails] = useState({});
  const [hasBadRequest, setHasBadRequest] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [providerIds, setProviderIds] = useState([]);
  const [faxRefresh, setFaxRefresh] = useState(false);
  const [isCallFromFax, setIsCallFromFax] = useState(false);
  // const[TenantID,setTenantID]=useState(tenantID)
  let [claimsIDsObj, setClaimsIDs] = useState({
    closeMatches: [],
    claims: [],
  });


  const fetchPatientDetails = async () => {
    try {
      const { data } = await API.get(
        `/${tenantID}/Patient/${patientIDNAME}`
      );
      if (data) {
        setPatientDetails(data);
      }
    } catch ({ response: { status } }) {
      if (status === 400) {
        setHasBadRequest(true);
      }
    }
  };

  useEffect(() => {
    setIsCallFromFax(isfax === "false" ? false : true);
    fetchPatientDetails();
  }, []);


  const handleClaimSelect = (ids, type) => {
    if (type) {
      claimsIDsObj.closeMatches = ids;
    } else {
      claimsIDsObj.claims = ids;
      setClaimIDs(ids);
    }

    if (!claimsIDsObj.claims.length) {
      setClaimsIDs({
        closeMatches: [],
        claims: [],
      });
    } else {
      setClaimsIDs(claimsIDsObj);
    }
  };

  const handleRxSelect = (rxNumbers) => {
    setRxNumbers(rxNumbers);
  };

  const toggleDrawer = (type) => {
    setOperationType(type);
    setIsOpen(!isOpen);
  };

  const onProviderSelect = (ids) => {
    setProviderIds(ids);
  };

  const faxRefetch = () => {
    setFaxRefresh((pre) => !pre);
    setRefresh((pre) => !pre);
  };

  const disabled = hasBadRequest;
  useEffect(() => {
    if (isOpen == true) {
      setIsOpen(false);

    }
  }, [orgId])
  console.log(location, "location")
  const handelPatienDetals = () => {
    refetch(true);
    setShowPatientDetails(false)
    //   if(location.pathname=="/fax"){
    //   navigate("/fax")

    // }
    // if(location.pathname=="/claims-manager"){
    //   navigate("/claims-manager")

    // }
  }

  return (
    <>
      <div className="">
        <Card className='shadow-top'>
          <CardBody>
            {
              isCallFromFax && <div className='d-flex align-items-center mb-3'>
                <Link
                  // to={location.pathname}
                  className='text-dark text-decoration-none'
                  state={{ reset: true }}
                >
                  {/* <FontAwesomeIcon icon={faArrowLeft} className='f-18' />
                   */}
                  <span
                    style={{
                      paddingRight: "0px",
                      alignItems: "center",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "8px", alignItems: "center" }} src={Arrow} onClick={() => { handelPatienDetals() }} />
                  </span>{" "}
                </Link>
                <h6 className='f-20 text-primary mb-0 ms-2 d-inline-block font-weight-700'>
                  Claim Details
                </h6>
              </div>
            }
            {
              !isCallFromFax && <div className='d-flex align-items-center mb-3'>
                <Link
                  to='/fax'
                  className='text-dark text-decoration-none'
                  state={{ reset: true }}
                >
                  {/* <FontAwesomeIcon icon={faArrowLeft} className='f-18' /> */}
                  <span
                    style={{
                      paddingRight: "0px",
                      alignItems: "center",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "8px", alignItems: "center" }} src={Arrow} onClick={() => { handelPatienDetals() }} />
                  </span>{" "}
                </Link>
                <h6 className='f-20 text-primary mb-0 ms-2 d-inline-block font-weight-700'>
                  Claim Details
                </h6>
              </div>
            }
            <Row className='align-items-end mb-2'>
              <Col>
                <ErrorBoundary>
                  <PatientDetails data={patientDetails} disabled={disabled} module={module} tenantID={tenantID}
                    patientId={patientIDNAME}
                    coveredEntity={coveredEntity} />
                </ErrorBoundary>
              </Col>
              <Col xs='auto'>
                <Button
                  color='primary'
                  outline
                  onClick={() => toggleDrawer('reject')}
                  disabled={disabled || !claimIDs.length}
                  hidden={true}
                >
                  Reject
                </Button>
                <Button
                  color='primary'
                  onClick={() => toggleDrawer('approve')}
                  disabled={disabled || !claimIDs.length}
                  hidden={true}
                >
                  Approve
                </Button>
              </Col>
            </Row>
            <ErrorBoundary>
              <PatientDetailsTable
                refresh={refresh}
                showpatientdetails={showpatientdetails}
                faxRefresh={faxRefetch}
                onRxSelect={handleRxSelect}
                onClaimSelect={handleClaimSelect}
                onProviderSelect={onProviderSelect}
                module={module}
                orgId={orgId}
                tenantID={tenantID}
                patientId={patientIDNAME}
                coveredEntity={coveredEntity}
              />
            </ErrorBoundary>
          </CardBody>
          <CardBody className='px-0'>
            <ErrorBoundary>
              <PatientDetailsTab
                refresh={refresh}
                claimIDs={claimIDs}
                faxRefresh={faxRefresh}
                providerIds={providerIds}
                claimsIDsObj={claimsIDsObj}
                onClaimSelect={handleClaimSelect}
                module={module}
                tenantID={tenantID}
                orgId={orgId}
                patientId={patientIDNAME}
                coveredEntity={coveredEntity}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </div>
      <Drawer
        size='lg'
        direction='end'
        isOpen={isOpen}
        toggle={toggleDrawer}
        title={`Claim - ${operationType === 'approve' ? 'Approve' : 'Reject'
          } Selected`}
      >
        <ErrorBoundary>
          <ClaimApproveReject
            ids={claimIDs}
            type={operationType}
            toggle={toggleDrawer}
            rxNumbers={rxNumbers}
            close={() => setIsOpen(false)}
            refetchdata={() => {
              setClaimIDs({ closeMatches: [], claims: [] });
              setRefresh((pre) => !pre);
              setClaimIDs([]);
            }}
            tenantID={tenantID}
            orgId={orgId}
            patientId={patientIDNAME}
            coveredEntityID={coveredEntity}
          />
        </ErrorBoundary>
      </Drawer>

      <ToastContainer position='top-right' autoClose={3000} />
    </>
  );
};

export default Patient;
